import "./src/styles/global.css";
// Import Swiper styles
import "swiper/css";

import wrapWithProvider from "./wrap-with-provider";
export const wrapRootElement = wrapWithProvider;
